(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-image')) {
    customElements.define(
      'announcement-image',
      class AnnouncementImage extends HTMLElement {
        connectedCallback() {
          if (this.dataset.slides === '0') return;
          this.current = 0;
          this.slides = Array.from(this.querySelectorAll('.text-slide, .image-slide'));
          this.interval = setInterval(() => {
            this.showSlide((this.current + 1) % this.slides.length);
          }, 5000);
        }
        showSlide(index) {
          this.slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
          this.current = index;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-local"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-local-timer')) {
    customElements.define(
      'countdown-local-timer',
      class LocalTimer extends HTMLElement {
        connectedCallback() {
          this.hours = this.dataset.hours;
          this.minutes = this.dataset.minutes;
          this.display = this.querySelector('.countdown__display');
          this.hoursDisplay = this.querySelector('.hours-display');
          this.minutesDisplay = this.querySelector('.minutes-display');
          this.secondsDisplay = this.querySelector('.seconds-display');

          this.completeMessage = this.dataset.completeMessage;

          if (!this.dataset.id) {
            console.warn('<countdown-local-timer> Missing required data-id attribute.');
            return;
          }
          this.storeKey = `local-timer-offset-${this.dataset.id}`;

          this.offset = this.#getStored();
          this.totalSeconds = this.hours * 3600 + this.minutes * 60;

          this.init();
        }

        init() {
          setInterval(() => {
            if (!this.timerComplete) {
              this.#calculate();
            }
          }, 1000);

          this.#calculate();
          this.display.style.visibility = 'visible';
          this.display.style.opacity = '1';
        }

        #calculate() {
          const now = Date.now();
          const elapsed = Math.floor((now - this.offset) / 1000);

          let remaining = this.totalSeconds - elapsed;

          if (remaining <= 0) {
            remaining = 0;
            this.timerComplete = true;
            clearInterval(this.interval);
            localStorage.setItem('X25vX2dpZnQ=', 'true');
            if (this.completeMessage) {
              this.innerHTML = `<div style="font-weight:bold;">${this.completeMessage}</div>`;
            }
          }

          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const seconds = remaining % 60;

          this.hoursDisplay.textContent = this.#pad(hours);
          this.minutesDisplay.textContent = this.#pad(minutes);
          this.secondsDisplay.textContent = this.#pad(seconds);
        }

        #pad(num) {
          return String(num).padStart(2, '0');
        }

        #getStored() {
          let stored = JSON.parse(localStorage.getItem(this.storeKey));
          if (stored && stored.expireTime && stored.expireTime <= Date.now()) {
            localStorage.removeItem('X25vX2dpZnQ=');
            localStorage.removeItem(this.storeKey);
            stored = null;
          }

          if (!stored) {
            let value = Date.now();
            if (localStorage.hasOwnProperty('local-timer-offset')) {
              value = parseInt(localStorage.getItem('local-timer-offset'), 10);
              localStorage.removeItem('local-timer-offset');
            }
            stored = {
              value: value,
              expireTime: Date.now() + 7 * 24 * 60 * 60 * 1000,
            };
            localStorage.setItem(this.storeKey, JSON.stringify(stored));
          }
          return parseInt(stored.value, 10);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealers-form"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('dealers-form')) {
      customElements.define(
        'dealers-form',
        class DealersForm extends HTMLElement {
          constructor() {
            super();
            this.onSubmit = this.onSubmit.bind(this);
          }
          connectedCallback() {
            this.form = this.querySelector('form');
            this.submitter = this.form.querySelector('.btn[type=submit]');
            this.formError = this.querySelector('.form-error');
            this.successNote = this.querySelector('.note--success');
            this.form.addEventListener('submit', this.onSubmit);
          }

          disconnectedCallback() {
            this.form.removeEventListener('submit', this.onSubmit);
          }

          async onSubmit(evt) {
            evt?.preventDefault();
            if (this.status === 'loading') return;

            this.formError.classList.add('hide');
            this.successNote.classList.add('hide');
            this.form.querySelectorAll('.input-full.error').forEach((i) => i.classList.remove('error'));

            try {
              this.status = 'loading';
              const formData = new FormData(this.form);
              this.submitter.classList.add('btn--loading');
              const response = await fetch(this.form.action, {
                method: this.form.method,
                body: formData,
              });
              if (response.status === 200 || response.status === 400) {
                const json = await response.json();
                if (response.status === 200) {
                  this.successNote.classList.remove('hide');
                  this.form.reset();
                } else {
                  const errors = json?.error?.fieldErrors || [];
                  let errMsg = '';
                  for (const [key, value] of Object.entries(errors)) {
                    const input = this.form.elements[key];
                    input.classList.add('error');
                    errMsg += `<li>${value[value.length - 1]}</li>`;
                  }
                  this.displayError(`<ul>${errMsg}</ul>`);
                }
              } else {
                throw new Error(response.statusText);
              }
            } catch (err) {
              console.log(err);
              this.displayError(`Error submitting form, please try again`);
            } finally {
              this.status = 'idle';
              this.submitter.classList.remove('btn--loading');
            }
          }

          displayError(message) {
            this.formError.innerHTML = message;
            this.formError.classList.remove('hide');
          }
        }
      );
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-column"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-column')) {
    customElements.define(
      'testimonials-column',
      class TestimonialsColumn extends HTMLElement {
        connectedCallback() {
          if (!this.$template) this.$template = this.querySelector('template');
          this.count = parseInt(this.dataset.count, 8) || 8;
          this.loadReviews();
        }

        async loadReviews() {
          const response = await fetch(
            `https://api.okendo.io/v1/stores/b22f4a33-c466-49da-b5af-80fccf1ba03e/reviews?limit=${this.count}&orderBy=date%20desc`
          );
          const json = await response.json();
          const reviewNode = this.$template.content.querySelector('.review-block');
          json.reviews.forEach((review) => {
            const blockElement = reviewNode.cloneNode(true);
            blockElement.querySelector('.testimonial-stars').textContent = '★'.repeat(review.rating);
            blockElement.querySelector('.review-title').textContent = review.title;
            blockElement.querySelector('.review-text').textContent = review.body;
            blockElement.querySelector('.reviewer .name').textContent = review.reviewer.displayName;
            this.appendChild(blockElement);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
